import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import styles from './Hero.module.css';
import { showComingSoon } from '../../App';

const Hero = () => {
  const handleClick = (e) => {
    e.preventDefault();
    showComingSoon();
  };

  const diceRef = useRef(null);
  const diceWrapperRef = useRef(null);
  const [rotation, setRotation] = useState({ x: 15, y: -15 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const dice = diceRef.current;
    const wrapper = diceWrapperRef.current;
    
    if (!dice || !wrapper) return;

    const handleMouseMove = (e) => {
      if (!isHovering) return;

      const bounds = wrapper.getBoundingClientRect();
      const mouseX = e.clientX - bounds.left;
      const mouseY = e.clientY - bounds.top;
      
      const rotateX = 30 - (mouseY / bounds.height * 60);
      const rotateY = (mouseX / bounds.width * 60) - 30;

      setRotation({ x: rotateX, y: rotateY });
    };

    const handleMouseEnter = () => {
      setIsHovering(true);
    };

    const handleMouseLeave = () => {
      setIsHovering(false);
      setRotation({ x: 15, y: -15 });
    };

    wrapper.addEventListener('mousemove', handleMouseMove);
    wrapper.addEventListener('mouseenter', handleMouseEnter);
    wrapper.addEventListener('mouseleave', handleMouseLeave);
    
    return () => {
      wrapper.removeEventListener('mousemove', handleMouseMove);
      wrapper.removeEventListener('mouseenter', handleMouseEnter);
      wrapper.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [isHovering]);

  const diceStyle = {
    transform: `translate(-50%, -50%) rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
    transition: isHovering ? 'none' : 'transform 0.5s ease-out'
  };

  return (
    <section className={`${styles.hero} section`}>
      <div className={`${styles.container} container`}>
        <motion.div 
          className={styles.content}
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className={styles.title}>
             The Best Framework to Build Lite Solana Games
          </h1>
          <p className={styles.subtitle}>
            Solar is the first modular developer framework for building fast, provably fair, and token-integrated games on Solana.
          </p>
          <div className={styles.cta}>
            <button onClick={handleClick} className="button button-primary">
              Get Started
            </button>
            <button onClick={handleClick} className="button button-secondary">
              Try a Live Demo
            </button>
          </div>
        </motion.div>

        <motion.div 
          className={styles.diceWrapper} 
          ref={diceWrapperRef}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div 
            className={styles.heroBackground}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          />
          <div 
            className={styles.dice} 
            ref={diceRef}
            style={diceStyle}
          >
            <div className={`${styles.diceFace} ${styles.front}`}>
              <div className={styles.dot}></div>
            </div>
            
            <div className={`${styles.diceFace} ${styles.back}`}>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
            </div>
            
            <div className={`${styles.diceFace} ${styles.right}`}>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
            </div>
            
            <div className={`${styles.diceFace} ${styles.left}`}>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
            </div>
            
            <div className={`${styles.diceFace} ${styles.top}`}>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
            </div>
            
            <div className={`${styles.diceFace} ${styles.bottom}`}>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero; 